module.exports = __webpack_public_path__ + "img/corn-and-black-bean-salad.db142143.jpg";